// ============================================================================
// Hero flip — per-cell randomized image swap (9-22s) after entrance reveal
// ============================================================================
(function ($) {
    'use strict';

    const reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    $(function () {
        const $hero  = $('#hero');
        if (!$hero.length) return;

        const cells = $hero.find('[data-flip]').toArray();
        if (!cells.length) return;

        // Pool of all image src-es from the markup
        const pool = Array.from(new Set(
            $hero.find('[data-flip] img').map(function () { return this.src; }).get()
        ));
        if (pool.length < 2) return;

        // Cadence (ms) — calm flips, staggered so they never fire together
        const startDelay     = 0;
        const minInterval    = 1000;
        const maxInterval    = 22000;
        const cellEnterStagger = 700;

        function rand(min, max) {
            return min + Math.random() * (max - min);
        }

        function pickDifferent(list, current) {
            if (list.length < 2) return current;
            let pick = current;
            for (let i = 0; i < 6 && pick === current; i++) {
                pick = list[Math.floor(Math.random() * list.length)];
            }
            return pick;
        }

        function flipCell(cell) {
            const flipper = cell.querySelector('.hero__cell-flipper');
            if (!flipper) return;

            const showingBack = flipper.classList.contains('is-flipped');
            const upcomingFaceSel = showingBack
                ? '.hero__cell-face--front'
                : '.hero__cell-face--back';
            const currentFaceSel = showingBack
                ? '.hero__cell-face--back'
                : '.hero__cell-face--front';

            const upcomingImg = cell.querySelector(`${upcomingFaceSel} img`);
            const currentImg  = cell.querySelector(`${currentFaceSel} img`);
            if (upcomingImg && currentImg) {
                upcomingImg.src = pickDifferent(pool, currentImg.src);
            }

            // Next frame — let the new src land before the rotation
            requestAnimationFrame(function () {
                flipper.classList.toggle('is-flipped');
            });
        }

        function scheduleNext(cell) {
            const delay = rand(minInterval, maxInterval);
            cell._flipTimer = setTimeout(function () {
                // Defer while tab is hidden
                if (document.hidden) {
                    cell._flipTimer = setTimeout(function () { scheduleNext(cell); }, 2000);
                    return;
                }
                flipCell(cell);
                scheduleNext(cell);
            }, delay);
        }

        function startFlipping() {
            cells.forEach(function (cell, i) {
                setTimeout(function () { scheduleNext(cell); },
                    startDelay + i * cellEnterStagger);
            });
        }

        // Wait for the entrance reveal to settle before scheduling flips
        function whenRevealed(cb) {
            const heroEl = $hero[0];
            if (heroEl.classList.contains('is-revealed')) {
                setTimeout(cb, 700);
                return;
            }
            const obs = new MutationObserver(function () {
                if (heroEl.classList.contains('is-revealed')) {
                    obs.disconnect();
                    setTimeout(cb, 700);
                }
            });
            obs.observe(heroEl, { attributes: true, attributeFilter: ['class'] });
        }

        whenRevealed(startFlipping);

        // Pause timers while tab is hidden (next scheduleNext re-arms them)
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) return;
            cells.forEach(function (cell) {
                if (cell._flipTimer) clearTimeout(cell._flipTimer);
            });
        });
    });
})(jQuery);
